import { useContext } from "react";

import { EditAgendaItemContext } from "./EditAgendaItemContext";

export function useEditAgendaItem() {
  const context = useContext(EditAgendaItemContext);
  if (!context) {
    throw new Error("useEditAgendaItem must be used within a EditAgendaItemProvider");
  }
  return context;
}
